<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> گزارش روزانه </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فیلتر جستجو -->

    <form class="row gx-2 gy-3" [formGroup]="mdl_Search">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> از تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> تا تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-primary w-100" (click)="search_Result()">

                جستجو

            </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-success w-100" (click)="exportExcel('Export_Excel')">

                خروجی اکسل

            </button>

        </div>

    </form>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2">

        <div class="row gx-0 gy-2 gy-md-0">

            <div class="col-12">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm
                    (keyup)="filter_list($event.target)">

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 235px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th class="text-center col-1"> # </th>

                        <th class="text-center col-1"> عملیات </th>

                        <th class="text-center"> تاریخ </th>

                        <th class="text-center"> دانش آموز </th>

                        <th class="text-center"> ثبت کننده </th>

                        <th class="text-center"> مرکز آموزشی </th>

                        <th class="text-center"> توضیحات </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Result;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td class="">

                            <ng-container>

                                <i class="fa fa-eye fa-lg mx-2 pointer" title="مشاهده" (click)="viewItem(item)"></i>

                            </ng-container>

                            <ng-container *ngIf="accessibility('bSchoolService_DailyReports_Delete')">

                                <i class="fa fa-trash fa-lg pointer" title="حذف" (click)="removeItem(item,i)"></i>

                            </ng-container>

                            <i class="fa fa-map-marker fa-lg mx-2 pointer" title="موقعیت"
                                (click)="open_Location(item)"></i>

                        </td>

                        <td> {{ item.strDate | faNum }} </td>

                        <td [innerHTML]="highlightText(item.strStudentFullName,searchTerm.value)"> </td>

                        <td [innerHTML]="highlightText(item.strFullName,searchTerm.value)"> </td>

                        <td [innerHTML]="highlightText(item.strMobileDomain_strComment,searchTerm.value)  | faNum">
                        </td>

                        <td> {{ item.strComment | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<!-- مدال مشاهده -->

<div class="modal fade" id="viewModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> مشاهده </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <section class="row gx-0 gy-0">

                    <!-- اطلاعات دانش آموز -->

                    <div class="col-12 col-md-5">

                        <div class="row gx-0 gy-md-0 gy-3 p-0 m-0">

                            <!-- تصویر -->

                            <div class="col-12 d-flex align-items-center justify-content-center p-2">

                                <img class="student-avatar" id="fullScreen_" (click)="fullScreen_Image()" src="{{obj_Std.strImage ? 'data:image/png;base64,' + obj_Std.strImage :
                                    
                                    '../../../assets/Img/preview__thumbnail.png' }}" loading="lazy">

                            </div>

                            <!-- نام دانش آموز -->

                            <div class="col-12 mb-3">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> نام دانش آموز : </span>

                                    <span class="text-primary"> {{ obj_Std.strStudentFullName }} </span>

                                </p>

                            </div>

                            <!-- پایه -->

                            <div class="col-12 col-md-6 mb-3">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> پایه : </span>

                                    <span class="text-primary"> {{ obj_Std.strGrade }} </span>

                                </p>

                            </div>

                            <!-- کلاس -->

                            <div class="col-12 col-md-6 mb-3">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> کلاس : </span>

                                    <span class="text-primary"> {{ obj_Std.strTitel }} </span>

                                </p>

                            </div>

                            <!-- کد ملی -->

                            <div class="col-12">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> کد ملی : </span>

                                    <span class="text-primary"> {{ obj_Std.strNationalCode | faNum }} </span>

                                </p>

                            </div>

                        </div>

                    </div>

                    <!-- اطلاعات -->

                    <div class="col-12 col-md-6 border-end pe-md-3">

                        <div class="row gx-0 gy-3 p-0 m-0">

                            <!-- تاریخ ثبت -->

                            <div class="col-12 col-md-6">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> تاریخ ثبت : </span>

                                    <span class="text-primary"> {{ obj_Std.strDate | faNum }} </span>

                                </p>

                            </div>

                            <!-- ساعت ثبت -->

                            <div class="col-12 col-md-6">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> ساعت ثبت : </span>

                                    <span class="text-primary"> {{ obj_Std.strTime | faNum }} </span>

                                </p>

                            </div>

                            <!-- ثبت کننده -->

                            <div class="col-12 col-md-6">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> ثبت کننده : </span>

                                    <span class="text-primary"> {{ obj_Std.strFullName | faNum }} </span>

                                </p>

                            </div>

                            <!-- محتوای گزارش -->

                            <div class="col-12">

                                <p class="mb-0">

                                    <span class="fw-bold text-muted"> محتوای گزارش : </span>

                                    <span class="text-primary"> {{ obj_Std.strComment | faNum }} </span>

                                </p>

                            </div>

                        </div>

                    </div>

                </section>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- نمایش موقعیت -->

<custom-map *ngIf="showCustom_Map" [strValue]="mdl_Request.get('strAddress')?.value"
    [longLat]="[mdl_Request.get('fLon')?.value,mdl_Request.get('fLat')?.value]" [isOpenModal]="true" [isView]="true"
    [skip_Search]="true" (mdl_Submit)="showCustom_Map=false">

</custom-map>